<template>
  <div class="bg-white">
    <div v-for="(q, i) in obj.questions" :key="i" class="mg-b-10 question">
      <div
        class="bd-y pd-5 bg-gray-100 font-weight-bolder"
        v-html="`${i + 1}. ${q.question}`"
      ></div>
      <div class="d-flex align-items-center pd-x-20">
        <div class="wd-50p">
          <div
            v-for="(a, ai) in q.answers"
            :key="ai"
            class="d-flex align-items-center bd-b"
          >
            <div class="pd-r-10 bd-r">{{ ai + 1 }}</div>
            <div :class="`pd-l-5 pd-y-5 ${a.point > 0 ? 'text-primary' : ''}`">
              {{ a.answer }}
            </div>
            <div class="mg-l-auto bd-l pd-l-5 wd-60 text-right">
              {{ a.count }}
            </div>
          </div>
        </div>
        <div class="wd-30p">
          <apexchart
            type="pie"
            :series="
              q.answers.map(a => {
                return a.count;
              })
            "
            :options="{
              legend: { show: false },
              chart: { width: 250, type: 'pie' },
              labels: q.answers.map(a => {
                return a.answer;
              })
            }"
          ></apexchart>
        </div>
        <div class="wd-20p" v-if="$route.params.ot != 700">
          <div class="row row-sm">
            <div class="col-6 col-sm-4 col-md-3 col-lg">
              <h4 class="tx-normal tx-rubik mg-b-10">
                {{
                  q.answers
                    .filter(x => x.point > 0)
                    .reduce((sum, { count }) => sum + count, 0)
                }}
              </h4>
              <div class="progress ht-2 mg-b-10">
                <div
                  class="progress-bar wd-100p bg-success"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h6
                class="tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02 mg-b-2"
              >
                Зөв хариулсан
              </h6>
            </div>
            <div class="col-6 col-sm-4 col-md-3 col-lg">
              <h4 class="tx-normal tx-rubik mg-b-10">
                {{
                  q.answers
                    .filter(x => x.point == 0)
                    .reduce((sum, { count }) => sum + count, 0)
                }}
              </h4>
              <div class="progress ht-2 mg-b-10">
                <div
                  class="progress-bar wd-100p bg-danger"
                  role="progressbar"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h6
                class="tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02 mg-b-2"
              >
                Буруу хариулсан
              </h6>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="d-flex align-items-center pd-x-20">
                 
                  <div class="wd-30p">
                       <apexchart type="pie" :series="q.answers.map((a)=>{ return a.count })"
                        :options="{legend:{show: false}, chart: { width: 250, type: 'pie', }, labels: q.answers.map((a)=>{ return a.answer }) }"></apexchart>
                  </div>
                  <div class="wd-40p" v-if="$route.params.ot!=700">
                      <div class="row row-sm">
                        <div class="col-6 col-sm-4 col-md-3 col-lg">
                            <h4 class="tx-normal tx-rubik mg-b-10">{{q.answers.filter(x=>x.point>0).reduce( (sum, { count }) => sum + count, 0 )}}</h4>
                            <div class="progress ht-2 mg-b-10">
                            <div class="progress-bar wd-100p bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6 class="tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02 mg-b-2">Зөв хариулсан</h6>
                        </div>
                        <div class="col-6 col-sm-4 col-md-3 col-lg">
                            <h4 class="tx-normal tx-rubik mg-b-10">{{q.answers.filter(x=>x.point==0).reduce( (sum, { count }) => sum + count, 0 )}}</h4>
                            <div class="progress ht-2 mg-b-10">
                            <div class="progress-bar wd-100p bg-danger" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                            <h6 class="tx-uppercase tx-spacing-1 tx-semibold tx-10 tx-color-02 mg-b-2">Буруу хариулсан</h6>
                        </div>
                      </div>
                  </div>
              </div> -->
    </div>
  </div>
</template>
<style scoped>
.question {
  page-break-before: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
  page-break-after: auto; /* 'always,' 'avoid,' 'left,' 'inherit,' or 'right' */
  page-break-inside: avoid; /* or 'auto' */
}
</style>
<script>
import { request } from "@/api/all";
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      showSidebar: false,
      obj: {
        rdy: false,
        questions: []
      }
    };
  },
  mounted() {
    this.init();
  },
  //   watch: {
  //     frmId(val) {
  //       if (val>0) {
  //         this.init();
  //       }
  //     }
  //   },
  methods: {
    ...mapActions(["handleMainLayoutConfig"]),
    init() {
      let _obj = this.$store.state.app.mainLayoutConfig;
      //   if (!m) {

      //   } else {
      //     _obj.header = null;
      //     _obj.expanded = true;
      //   }
      _obj.header = 0;
      _obj.aside = false;
      _obj.expanded = false;

      this.handleMainLayoutConfig(_obj);
      if (this.$route.params.ot == 700) {
        request({
          api: { method: "GET", url: "Form/GetSurveyFilledChartData" },
          params: { examId: this.$route.params.id, courseId: this.$route.params.cid, lessonId: this.$route.params.lid },
          store: this.$store
        }).then(res => {
          this.obj.questions = res.data.questions;
          this.obj.rdy = true;
          //console.log(res);
        });
      } else {
        request({
          api: { method: "GET", url: "Form/GetExamFilledChartData" },
          params: { examId: this.$route.params.id },
          store: this.$store
        }).then(res => {
          this.obj.questions = res.data.questions;
          this.obj.rdy = true;
          //console.log(res);
        });
      }

      this.showSidebar = true;
    },
    visibleChanged(e) {
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-task-close");
      }
    }
  }
};
</script>

<style></style>
